export default "__VITE_ASSET__BJQT1ZeV__"